export function getView(is_hovered) {
  return is_hovered ? 'Seat' : 'No'
}
